import React from "react";
import {Route, Router, Switch} from "react-router-dom";

export const Routes = ({
                           history,
                           OAuthCallback,
                           ProtectedRoute,
                       }) => {
    return (
        <Router history={history}>
            <Switch>
                <Route path="/oauth-callback" component={OAuthCallback}/>
                <ProtectedRoute path="/"/>
            </Switch>
        </Router>
    );
};